var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('selector',{attrs:{"options":_vm.options},model:{value:(_vm.editingSource),callback:function ($$v) {_vm.editingSource=$$v},expression:"editingSource"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }